import { Icon } from '@iconify/react';
import { Button } from '@/components/shadcn/button';

interface PadelEditSkorFooterProps {
  running: boolean;
  saving: boolean;
  onToggleTimer: () => void;
  onSave: () => void;
}

export default function PadelEditSkorFooter({
  running,
  saving,
  onToggleTimer,
  onSave,
}: PadelEditSkorFooterProps) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 grid grid-cols-2 gap-2 bg-white p-4 pb-safe">
      <Button
        type="button"
        variant="secondary"
        onClick={onToggleTimer}
        className="h-12 rounded-full bg-[#FFF1EC] text-sm font-bold text-[#FC480D] hover:bg-[#FFE4D8]"
      >
        <Icon icon={running ? 'mdi:pause' : 'mdi:play-outline'} className="h-4 w-4" />
        {running ? 'Jeda Timer' : 'Mulai Timer'}
      </Button>
      <Button
        type="button"
        disabled={saving}
        onClick={onSave}
        className="h-12 rounded-full bg-[#FC480D] font-bold text-white hover:bg-[#D83B08]"
      >
        <Icon icon="mdi:check-circle-outline" className="h-4 w-4" />
        Simpan Skor
      </Button>
    </div>
  );
}
